import { Injectable } from '@angular/core';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';

interface AppConfig {
  zitadelAuthority: string;
  zitadelClientId: string;
  zitadelRedirectUrl: string;
  zitadelPostLogoutRedirectUri: string;
  apiHost: string;
  apiUrl: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: AppConfig | null = null;
  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = fetch('/config.json')
        .then(r => {
          if (!r.ok) throw new Error(`Failed to load /config.json: HTTP ${r.status}`);
          return r.json() as Promise<AppConfig>;
        })
        .then(c => { this.config = c; });
    }
    return this.loadPromise;
  }

  get apiHost(): string { return this.config!.apiHost; }
  get apiUrl(): string { return this.config!.apiUrl; }

  get oidcConfig(): OpenIdConfiguration {
    const c = this.config!;
    return {
      authority: c.zitadelAuthority,
      clientId: c.zitadelClientId,
      redirectUrl: c.zitadelRedirectUrl,
      postLogoutRedirectUri: c.zitadelPostLogoutRedirectUri,
      responseType: 'code',
      scope: 'openid profile email offline_access',
      silentRenew: true,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true,
      logLevel: 1,
    };
  }
}
